import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Shortcut.scss";

export default function Shortcut(props) {
  const [buttons, setButtons] = useState([
    {
      title: "فاکتور فروش",
      class: "btn-outline-success",
      link: "/Operation/2-m",
    },
    {
      title: "فاکتور خرید",
      class: "btn-outline-primary",
      link: "/Operation/1-m",
    },
    { title: "افزودن کالا", class: "btn-outline-info", link: "/Operation/473-s" },
  ]);
  return (
    <div className="shortcut-container">
      {buttons.map((button, index) => {
        return (
          <Link key={index} to={button.link} className={"btn " + button.class}>
            {button.title}
          </Link>
        );
      })}
      {props.ShowAdminReport===true ? <Link to={"/adminReport"} className={"btn btn-info"}>
        گزارش مدیریتی
      </Link>:<></>}
    </div>
  );
}
